import { Box, styled, Grid, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../../api';
import ProgressBar from '../../../components/ProgressBar';
import { EmergencyGate, EmergencyGroup } from '../../../schema/emergency';

interface EmergencyStart {
  handleOnClickInfo: (roleId: number | string) => void;
  handleOnClickExport: (roleId: number | string) => void;
}
const EmergencyStart = ({ handleOnClickInfo, handleOnClickExport }: EmergencyStart) => {
  const [mainEmergencyGroupList, setMainEmergencyGroupList] = useState<EmergencyGroup[]>([]);
  const [subEmergencyGroupList, setSubEmergencyGroupList] = useState<EmergencyGroup[]>([]);
  const [gateList, setGateList] = useState<EmergencyGate[]>([]);

  useEffect(() => {
    api.get<EmergencyGroup[]>(`/emergency/group`, { params: { is_main: true } }).then((res) => {
      const { data } = res;
      setMainEmergencyGroupList(data);
    });
    api.get<EmergencyGroup[]>(`/emergency/group`, { params: { is_main: false } }).then((res) => {
      const { data } = res;
      setSubEmergencyGroupList(data);
    });
    api.get<EmergencyGate[]>(`/emergency/gate`).then((res) => {
      const { data } = res;
      setGateList(data);
    });
    const interval = setInterval(() => {
      api.get<EmergencyGroup[]>(`/emergency/group`, { params: { is_main: true } }).then((res) => {
        const { data } = res;
        setMainEmergencyGroupList(data);
      });
      api.get<EmergencyGroup[]>(`/emergency/group`, { params: { is_main: false } }).then((res) => {
        const { data } = res;
        setSubEmergencyGroupList(data);
      });
      api.get<EmergencyGate[]>(`/emergency/gate`).then((res) => {
        const { data } = res;
        setGateList(data);
      });
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <Grid container columns={2} spacing={3}>
        {gateList.map((data, index) => {
          return (
            <Grid item xs={1} key={index}>
              <Paper sx={{ mt: 2 }}>
                <CardContainer sx={{ px: 4, height: "100% !important" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      paddingRight: 1,
                      textDecoration: 'underline',
                      textDecorationThickness: 5,
                      textDecorationColor: '#20ccf5'
                    }}
                  >
                    {data.gate_name}
                  </Typography>
                  <Typography variant="h2">{data.total_count}</Typography>
                </CardContainer>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
      <Grid container columns={mainEmergencyGroupList.length} spacing={3} my={3}>
        {mainEmergencyGroupList.map((data, index) => (
          <Grid item xs={1} key={index}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6">{data.group_name}</Typography>
              {data.roles.map((item, index) => {
                // if (item.total == 0) {
                //   return;
                // }
                return (
                  <ProgressBar
                    key={index}
                    name={item.role_name}
                    divider={item.total_count}
                    divide={item.total}
                    color="#20ccf5"
                    bgColor="#c2f3ff"
                    // handleOnClickPdf={() => console.log('pdf')}
                    handleOnClickExcel={() => handleOnClickExport(item.id)}
                    handleOnClickInfo={() => handleOnClickInfo(item.id)}
                  />
                );
              })}
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={3} columns={subEmergencyGroupList.length} mt={3}>
        {subEmergencyGroupList.map((data, index) => (
          <Grid item xs={1} key={index}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6">{data.group_name}</Typography>
              {data.roles.map((item, index) => {
                // if (item.total == 0) {
                //   return;
                // }
                return (
                  <ProgressBar
                    key={index}
                    name={item.role_name}
                    divider={item.total_count}
                    divide={item.total}
                    // handleOnClickPdf={() => console.log('pdf')}
                    handleOnClickExcel={() => handleOnClickExport(item.id)}
                    handleOnClickInfo={() => handleOnClickInfo(item.id)}
                  />
                );
              })}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default EmergencyStart;

const CardContainer = styled(Box)`
  height: 20vh;
  display: flex;
  padding: 24px;
  align-items: center;
  justify-content: space-between;
`;
